import { useMemo } from 'react'

import { Box } from '@mui/material'
import { FormConfig } from '@workwave-tidal/core/form'

import { form } from './../../../../formState'

import { useController } from '../../../../hooks/useController'
import { useOnSubmit } from '../../../../hooks/useOnSubmit'

import { TestEmailNotificationFormValues } from '@/components/modals/TestEmailNotificationModal/types'
import { ReadyFooter } from '../../../Footer/components/ReadyFooter'
import { Email } from './Email'

export function ReadyBody() {
  const {
    data: { notification, values },
  } = useController()

  const submit = useOnSubmit(notification, values)

  const configs = useMemo<FormConfig<TestEmailNotificationFormValues>>(
    () => ({
      id: 'test-email-notification-form',
      initialValues: { email: '' },
    }),
    [values],
  )

  return (
    <Box height={150}>
      <form.Form
        config={configs}
        requireTransaction={false}
        stopEditingOnUnmount
        applyPendingFitMapOnMount={false}
        width="auto"
        onSubmit={submit}
        footer={<ReadyFooter />}
        disableScroll
        fieldsPadding="16px 0"
      >
        <Email />
      </form.Form>
    </Box>
  )
}
